module.exports = __webpack_public_path__ + "static/media/a-ending inkjekjønn.f118ced3.mp3";